import React from 'react';

import { icon_arrow_right } from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';
import { ProductType } from '@gn-audio/jss-core/common/enums/product-type.enum';

import { ProductCatalogProductWithPrice } from 'components/Product/AccessorySpot/AccessorySpot';
import { Price } from 'composables/Product/Buy/Price/Price';

export type SliderCardWithPriceProps = {
  accessory: ProductCatalogProductWithPrice;
};

const SliderCardWithPrice = ({ accessory }: SliderCardWithPriceProps): React.ReactElement => {
  return (
    <div className="light flex w-[21rem] flex-col gap-3 rounded-3xl bg-white shadow-md md:w-[24rem]">
      <img
        className="h-[16.25rem] w-full rounded-t-3xl bg-gray-50 object-contain"
        src={accessory.thumbnailUrl}
        alt={accessory.name}
      />
      <section className="flex h-full flex-col p-6">
        <div>
          <h3 className="mb-6 text-xl font-bold" id={`headerCard-${accessory.sku}`}>
            {accessory.name}
          </h3>
        </div>
        <div className="flex flex-1 flex-col items-start justify-end">
          <Price
            productType={ProductType.Product}
            segmentType={accessory.segmentType}
            price={accessory.price}
          />
        </div>
        <div className="mt-auto flex justify-end">
          <Button
            variant="tertiary"
            asLink
            href={accessory.pageUrl}
            size="l"
            icon={<JabraIcon Icon={icon_arrow_right} />}
            aria-labelledby={`headerCard-${accessory.sku}`}
          />
        </div>
      </section>
    </div>
  );
};

export default SliderCardWithPrice;
